import { NavItem } from 'src/interfaces/navitem.interface';

export const QueryUiNav: { [key: string]: NavItem } = {
  Download: {
    route: 'download/:id',
    title: 'page_download',
    icon: '',
  },
};
export const returnUrlKey: string = 'returnUrl';

export const AppNav: { [key: string]: NavItem } = {
  Login: {
    route: 'login',
    title: 'page_login',
    icon: '',
  },
  Home: {
    route: '',
    title: 'page_home',
    icon: 'icon-home-fill',
  },
  QueryInvoices: {
    route: 'query-invoices',
    title: 'page_query_invoices',
    icon: 'icon-downloadBox-fill',
  },
  TransactionQuery: {
    route: 'transaction-query',
    title: 'page_transaction_query',
    icon: 'icon-downloadBox-fill',
  },
  StatusMonitor: {
    route: 'status-monitor',
    title: 'page_status_monitor',
    icon: 'icon-time-fill',
  },
  QueryInvoicesStatus: {
    route: 'invoices',
    title: 'page_query_invoices_status',
    icon: '',
  },
  TransactionQueryStatus: {
    route: 'transactions',
    title: 'page_transaction_query_status',
    icon: '',
  },
  Admin: {
    route: 'admin',
    title: 'page_admin',
    icon: 'icon-settings-fill',
  },
  QueryUI: {
    route: 'queryUI',
    title: '',
    icon: '',
    children: [QueryUiNav.Download],
  },
  AdmminManageTechnicalUsers: {
    route: 'manage-technicalusers',
    title: 'page_admin_manage_technicalusers',
    icon: 'icon-partnership-fill',
  },
  Help: {
    route: 'help',
    title: 'page_help',
    icon: 'icon-helpQuestion-fill',
  },
  Error404: {
    route: '404',
    title: 'page_error404',
    icon: '',
  },
  NotAuthenticated: {
    route: 'notauthenticated',
    title: 'page_notauthenticated',
    icon: '',
  },
  AccessDenied: {
    route: 'accessdenied',
    title: 'page_accessdenied',
    icon: '',
  },
  AccessManagement: {
    route: 'access',
    title: 'page_access_management',
    icon: 'icon-newUser-fill',
  },
  RequestAccess: {
    route: 'request-access',
    title: 'page_request_access',
    icon: '',
  },
  AccessRequests: {
    route: 'access-requests',
    title: 'page_access_requests',
    icon: '',
  },
  ManageEngagements: {
    route: 'manage-engagements',
    title: 'page_manage_engagements',
    icon: '',
  },
  Approval: {
    route: 'request/:id',
    title: 'page_request',
    icon: '',
  },
};
